import { defineComponent as _defineComponent } from 'vue'
import {watch, ref, computed, onMounted} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'tabs',
  props: ['items', 'modelValue'],
  emits: ['change','update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;

const tabsValue = computed({
	get() {
		return props.modelValue;
	},
	set(value) {
		emit('update:modelValue', value);
		emit('change', value);
	},
});

const isActived = computed(() => {
	return (itemVal: string) => {
		return tabsValue.value === itemVal;
	};
});

function tabs_change(tabVal: any) {
	tabsValue.value = tabVal.value;
}

const __returned__ = { props, emit, tabsValue, isActived, tabs_change }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})